import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import Button from '../Button';
import { ArrowDown } from '@icons/common';

const AbstractToggler = ({ label, children, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <StyledAbstractToggler {...rest}>
      <TogglerTitle functional onClick={() => setIsOpen(!isOpen)}>
        {label}
        <StyledToggleIcon isOpen={isOpen} />
      </TogglerTitle>
      {isOpen && children}
    </StyledAbstractToggler>
  );
};

const StyledAbstractToggler = styled.div``;

export const TogglerTitle = styled(Button)`
  display: flex;
  align-items: center;
`;

export const StyledToggleIcon = styled(ArrowDown)`
  margin-left: 5px;
  width: 12px;
  height: 6px;

  path {
    fill: ${props => props.theme.colors.blackBase};
  }

  ${props =>
    !props.isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

AbstractToggler.propTypes = {
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

AbstractToggler.defaultProps = {
  className: '',
};

export default React.memo(AbstractToggler);
